import type { CreateShopOverrideRuleDto, ShopOverrideRuleDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseCreateShopOverrideRuleParams {
	onSuccess?: (data: ShopOverrideRuleDto[]) => void;
}

export default function useCreateShopOverrideRule(
	shopId: string,
	options?: UseCreateShopOverrideRuleParams,
) {
	return useApiMutation("post", "/shops/{shopId}/override-rules", {
		onSuccess: options?.onSuccess,
		mapVariables: (requestBody: CreateShopOverrideRuleDto) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
